const classBarHidden = 'notification-bar--hidden';

$('.notification-bar').each(function () {
    let $bar = $(this),
        $close = $bar.find('.notification-bar__close');

    $bar.css('height', $bar.outerHeight()); // for animating to zero when hidden

    $(window).on('resize', function () {
        // recalculate bar height on window resize
        $bar.css('height', 'auto');
        $bar.css('height', $bar.outerHeight());
    });

    $close.on('click', function () {
        $bar.addClass(classBarHidden);

        // call for resetting sticky masthead treshold - see ./sticky-masthead.js
        setTimeout(function () {
            $('.masthead__bottom').trigger('reset');
        }, 500);
    });
});